





































import 'vue-awesome/icons/sync-alt'
export default
  name: 'offline_bar'
  props:
    mode:
      default: 'notice'
  data: ->
    modal_visible: false
    style: ''
    loading_text: ''
  mounted: ->
    window.addEventListener 'online',  => @$store.state.ui.online = true
    window.addEventListener 'offline', => @$store.state.ui.online = false
    @$watch '$store.state.ui.loaded', @setStyle, { immediate: true }
  methods:
    setStyle: ->
      if @$store.state.ui.loaded == 'network_transactions'
        @style = { display: 'none' }
        @loading_text = ''
      else if @$store.state.ui.loaded == 'network_user'
        @style = { color: 'green' }
        @loading_text = '' if HM.is_english
        @loading_text = '' if HM.is_russian
      else if @$store.state.ui.loaded == 'localstorage'
        @style = { color: 'orange' }
        @loading_text = '' if HM.is_english
        @loading_text = '' if HM.is_russian
      else
        @style = { color: 'red' }
        @loading_text = '' if HM.is_english
        @loading_text = '' if HM.is_russian
    showModal: ->
      @$emit 'showModal'
      @$store.dispatch('hideTransactionsPopovers')
      @$store.state.ui.offline_modal = true
    hideModal: -> @$store.state.ui.offline_modal = false
